import Immutable = require('immutable')
import React = require('react')

import { AddressForm } from './AddressForm'
import { Choice } from './Choice'
import { deviceImages } from './data'
import { DetailsForm } from './DetailsForm'
import { AddressFormData, DetailsFormData, IChoice, IConfiguration, IQuestion, ISettings, StoreQuoteData } from './models'
import { Quote } from './Quote'
import { AsyncPost, Dictionary, getChoices, getChoiceValue, getModelChoice } from './utils'

declare var ga, $;

interface Properties {
    index: number;                                  // At which index does the question appear
    question: IQuestion;                            // Question to render
    userChoices: string[];                          // Choices that were made until now by the user
    quote: number                                   // Quoted amount
    configurations: IConfiguration[];               // All available configurations at this point
    settings: ISettings;                            // Wizard settings
    postData: AsyncPost<any,any>;
    detailsData: AsyncPost<DetailsFormData, any>;   // Details form async post data
    addressData: AsyncPost<AddressFormData, any>;   // Address form async post data
    sendQuoteByEmail: AsyncPost<StoreQuoteData, any>           // Send quote by email async post data
}

interface Callbacks {
    onChoice: (choice: string) => void                      // Triggered when the user picks one of the choices
    onDetailsFormSubmit: (data: DetailsFormData) => void    // Triggered when the user submits the details form
    onQuoteAccepted: () => void                             // Triggered when the user accepts the quote
    onReplacementAccepted: () => void                       // Triggered when the user accepts device replacement
    onEmailQuote: () => void                                // Triggered when the user selects to receive the quote on email
    onSearchTechnician: () => void                          // Triggered when the user wants to find a technician around
    onAddressFormSubmit: (data: AddressFormData) => void    // Triggered when the user submits the address form
}

interface Props extends Properties, Callbacks {}

interface State {
    showPleaseSpecify: boolean
    isSelected?: Dictionary<boolean>
}

export class Question extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            showPleaseSpecify: false,
            isSelected: {}
        }
    }

    componentWillUpdate(nextProps: Props) {
        if (nextProps.userChoices.length > this.props.userChoices.length && nextProps.userChoices.length === nextProps.index ) {
            this.setState({
                showPleaseSpecify: false,
                isSelected: {}
            })
        }
    }

    shouldComponentUpdate(nextProps: Props, nextState: State) {
        // We are updating the component only when the question comes up
        return nextProps.userChoices.length === nextProps.index || nextState !== this.state;
    }

    triggerOnChoiceCallback(choice: string) {
        this.props.onChoice(choice);
        this.setState({
            showPleaseSpecify: false
        })
    }

    getSelectedChoices() : string[] {
        return Immutable.Map(this.state.isSelected).filter( (v,k) => v == true).keySeq().toJS();
    }

    handleChoiceClick(choice: IChoice|string) {
        var choiceName = getChoiceValue(choice);

        if (this.props.question.isMultipleChoice) {

            ga('send', 'event', 'Wizard', 'choice-selected');

            // We are dealing with multiple choice so we just toggle the selections
            this.setState({
                showPleaseSpecify: this.state.showPleaseSpecify,
                isSelected: Immutable.Map(this.state.isSelected).update(choiceName, oldValue => !oldValue).toJS()
            });
        } else {

            // We are dealing with single choices so we trigger the callback

            if (typeof choice == "string") {
                this.triggerOnChoiceCallback(choice as string);
            } else {
                if ( (choice as IChoice).showTextbox ) {
                    this.setState({
                        showPleaseSpecify: true
                    });
                } else {
                    this.triggerOnChoiceCallback(choiceName)
                }
            }
        }
    }

    handleDoneBtnClick() {
        var otherValue = $('#inputSpecify').val();
        if (otherValue.length > 0) {
            this.triggerOnChoiceCallback(otherValue);
        }
    }

    handleNextBtnClick() {
        ga('send', 'event', 'Wizard', 'next-btn-click');
        var selected = this.getSelectedChoices();
        if (selected.length > 0) {
            this.triggerOnChoiceCallback(selected.join(','))
        }
    }

    render() {
        var choices;

        if (this.props.question.showQuote) {
            choices = <Quote
                configurations={this.props.configurations}
                quote={this.props.quote}
                sendQuoteByEmail={this.props.sendQuoteByEmail}
                onQuoteAccepted={this.props.onQuoteAccepted}
                onReplacementAccepted={this.props.onReplacementAccepted}
                onEmailQuote={this.props.onEmailQuote}
                // onSearchTechnician={this.props.onSearchTechnician}
            />
        } else if (this.props.question.showDetailsForm) {
            choices = <DetailsForm postData={this.props.detailsData} onSubmit={this.props.onDetailsFormSubmit} />
        } else if (this.props.question.showAddressForm) {
            choices = <AddressForm postData={this.props.addressData} onSubmit={this.props.onAddressFormSubmit} />
        } else {
            choices = Immutable.List(getChoices(this.props.configurations, this.props.index))
                .map((choice, index) => {

                    var givenChoice : IChoice|string = choice;

                    if (this.props.index == 0) {
                        givenChoice = {
                            name:  choice,
                            image: deviceImages[choice]
                        }
                    }

                    if (this.props.index === 1) {
                        givenChoice = {
                            name:    choice,
                            altName: getModelChoice(this.props.userChoices[0], choice)
                        }
                    }

                    if (this.props.index === 3) {
                        givenChoice = {
                            name:    choice,
                            altName: `${choice} GB`
                        }
                    }

                    return (
                        <Choice
                            key={index}
                            choice={givenChoice}
                            isSelected={this.state.isSelected[choice]}
                            onClick={this.handleChoiceClick.bind(this)}
                        />
                    )
                }).toArray();

            /*choices = Immutable.List(getMostSpecific(filterChoices(this.props.question.choices, this.props.userChoices)))
                .map((choice) => {
                    return <Choice
                        key={getChoiceName(choice)}
                        choice={choice}
                        onClick={this.handleChoiceClick.bind(this)}/>;
                }).toArray();*/
        }

        var pleaseSpecify;

        if (this.state.showPleaseSpecify) {
            pleaseSpecify = <div className="cc-question__please_specify text-center">
                <div className="form-group form-group-lg text-center">
                    <label htmlFor="inputSpecify">Please Specify</label>
                    <input type="text" className="form-control input-lg" id="inputSpecify" placeholder="Please Specify" />
                </div>
                <button className="btn btn-success btn-cc-green" onClick={this.handleDoneBtnClick.bind(this)}>Done</button>
            </div>
        }

        var nextButton;

        if (this.props.question.isMultipleChoice) {
            nextButton = <div className="cc-question__next-btn-wrapper">
                <button className="btn btn-success btn-cc-green btn-lg" disabled={this.getSelectedChoices().length == 0} onClick={this.handleNextBtnClick.bind(this)}>Next</button>
            </div>
        }

        var sendEmailNote;

        if (this.props.question.showSendEmailNote) {
            sendEmailNote = <div className="cc-question__issue-not-listed text-center">
                <div>Is your issue not listed here?</div>
                <a className="btn btn-link" href="mailto:info@cellclinic.co.za">Click here to email us</a>
            </div>
        }


        if (this.props.index == this.props.userChoices.length) {

            return <div className="cc-question">
                <div className="cc-question__title">{this.props.question.title}</div>
                <div className="cc-question__choices-wrapper" ref="choices-wrapper">
                    {choices}
                    {pleaseSpecify}
                    {nextButton}
                    {sendEmailNote}
                </div>
            </div>;

        } else {
            return null;
        }

    }
}
